export const APP_MENU_DRAWER_WIDTH = 300;
